import React from "react";

export default function LoadingPage() {
    return (
        <div className="limiter">
            <div className="container-login100">
                <div className="wrap-login100">
                    <form className="form-404">
                        <span className="login100-form-logo">
                            <img alt="" src="assets/img/logo/login-logo.png" />
                        </span>
                        <span className="form404-title p-b-34 p-t-27">Loading...</span>
                        <p className="content-404">Please Wait..</p>
                        <div className="container-login100-form-btn"></div>
                    </form>
                </div>
            </div>
        </div>
    );
}
